import type { ComponentProps, ReactNode } from 'react';
import { Button, Modal, tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import type { GlobalModalProps } from '~/subscription-management/external-dependencies/webapp-utils';

type FooterAction = Pick<ComponentProps<typeof Button>, 'children' | 'kind'> & {
  onClickType: 'cancel' | 'submit';
};

interface Props extends GlobalModalProps<void, void> {
  contentLabel: string;
  children: ReactNode;
  footerActions: FooterAction[];
}

const S = {
  ModalBody: styled(Modal.Body)`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    flex-wrap: wrap;
  `,
  ModalBodyInner: styled.div`
    display: flex;
    flex-direction: column;
    max-width: 800px;
    gap: ${tokens.spacer.x5};
  `,
};

export function ConfirmOrderContent({
  onCancel,
  onSubmit,
  children,
  contentLabel,
  footerActions,
}: Props): JSX.Element {
  return (
    <Modal
      isOpen
      contentLabel={contentLabel}
      size="fullscreen"
      onClose={onCancel}
      appElementSelector="#app-container"
    >
      <S.ModalBody>
        <S.ModalBodyInner>{children}</S.ModalBodyInner>
      </S.ModalBody>
      <Modal.Footer>
        {footerActions.map(({ children: actionChildren, kind, onClickType }) => (
          <Button
            key={actionChildren}
            kind={kind}
            onClick={() => (onClickType === 'cancel' ? onCancel() : onSubmit())}
          >
            {actionChildren}
          </Button>
        ))}
      </Modal.Footer>
    </Modal>
  );
}
